import { render, staticRenderFns } from "./Estoques.vue?vue&type=template&id=2e5b4cfc&scoped=true"
import script from "./Estoques.vue?vue&type=script&lang=js"
export * from "./Estoques.vue?vue&type=script&lang=js"
import style0 from "./Estoques.vue?vue&type=style&index=0&id=2e5b4cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b4cfc",
  null
  
)

export default component.exports